interface Props {
  className?: string;
}

export default function ComoTrabajamosSection({ className }: Props) {
  return (
    <section className={className || "py-8 md:py-14 bg-gradient-to-br from-background-50 via-primary-50/15 to-accent-50/20"}>
      <div className="px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-6 md:mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3 font-heading">
            Cómo trabajamos — fácil, rápido y sin sorpresas
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Tres pasos. Sin letra pequeña. Sin compromiso.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {/* Paso 1 */}
          <div className="bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/60 text-center relative">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center font-extrabold text-sm shadow-lg shadow-primary-500/20">
              1
            </div>
            <div className="mt-2">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-600 mx-auto mb-4">
                <span className="w-6 h-6 flex items-center justify-center"><i className="ri-phone-fill text-2xl"></i></span>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2.5">Llámanos o escríbenos</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                Cuéntanos qué te pasa con tu persiana o mosquitera. Te escuchamos, te orientamos y concertamos una visita cuando mejor te venga. Respuesta en menos de 15 minutos.
              </p>
              <div className="flex flex-col gap-2">
                <a href="tel:+34951120770" className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-xs px-5 py-2.5 rounded-full transition-all whitespace-nowrap cursor-pointer">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill"></i></span>
                  951 12 07 70
                </a>
                <a href="https://wa.me/34627213347" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1faa52] text-white font-semibold text-xs px-5 py-2.5 rounded-full transition-all whitespace-nowrap cursor-pointer">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-whatsapp-fill"></i></span>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>

          {/* Paso 2 */}
          <div className="bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/60 text-center relative">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-accent-500 text-background-50 flex items-center justify-center font-extrabold text-sm shadow-lg shadow-accent-500/20">
              2
            </div>
            <div className="mt-2">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500/10 text-accent-600 mx-auto mb-4">
                <span className="w-6 h-6 flex items-center justify-center"><i className="ri-file-search-line text-2xl"></i></span>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2.5">Diagnóstico y presupuesto gratis</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                Nos desplazamos a tu domicilio sin coste. Revisamos la avería, te explicamos exactamente qué pasa y te damos un presupuesto cerrado por escrito antes de hacer nada. Tú decides si quieres que lo hagamos o no. Sin presión, sin compromiso.
              </p>
            </div>
          </div>

          {/* Paso 3 */}
          <div className="bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/60 text-center relative">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-secondary-600 text-background-50 flex items-center justify-center font-extrabold text-sm shadow-lg shadow-secondary-600/20">
              3
            </div>
            <div className="mt-2">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-500/10 text-secondary-600 mx-auto mb-4">
                <span className="w-6 h-6 flex items-center justify-center"><i className="ri-shield-check-line text-2xl"></i></span>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2.5">Reparación con garantía</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                Si aceptas el presupuesto, empezamos en el momento. La mayoría de reparaciones se terminan en la misma visita. Todo nuestro trabajo incluye 2 años de garantía por escrito, cubriendo piezas y mano de obra. Te vas con la persiana funcionando y la tranquilidad de que si algo falla, volvemos sin coste.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}